var React = require('react');

function FacebookLarge (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.024 35.7148H6.65577C5.74105 35.7148 5 34.9733 5 34.059V7.3706C5 6.456 5.74116 5.71484 6.65577 5.71484H33.3443C34.2587 5.71484 35 6.456 35 7.3706V34.059C35 34.9735 34.2586 35.7148 33.3443 35.7148H25.6996V24.0972H29.5991L30.183 19.5696H25.6996V16.679C25.6996 15.3681 26.0636 14.4748 27.9433 14.4748L30.3408 14.4738V10.4243C29.9262 10.3691 28.503 10.2458 26.8472 10.2458C23.3905 10.2458 21.024 12.3558 21.024 16.2306V19.5696H17.1145V24.0972H21.024V35.7148Z","fill":"white"}));
}

FacebookLarge.defaultProps = {"width":"40","height":"41","viewBox":"0 0 40 41","fill":"none"};

module.exports = FacebookLarge;

FacebookLarge.default = FacebookLarge;
